import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      // 仪表板
      path: '/',
      name: 'dashBoard',
      meta: {
        menu: '/'
      },
      component: resolve => require(['@/pages/user/dashBoard'], resolve)
    },
    {
      // 账户查询
      path: '/accountQuery',
      name: 'accountQuery',
      meta: {
        menu: '/accountQuery',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/user/accountQuery'], resolve)
    },
    {
      // 账户查询详情
      path: '/accountQueryDetails',
      name: 'accountQueryDetails',
      meta: {
        menu: '/accountQuery'
      },
      component: resolve => require(['@/pages/user/accountQuery/detail'], resolve)
    },
    {
      // 账户冻结
      path: '/accountFreeze',
      name: 'accountFreeze',
      meta: {
        menu: '/accountFreeze',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/user/accountFreeze'], resolve)
    },
    {
      // 账户冻结详情
      path: '/accountFreezeDetails',
      name: 'accountFreezeDetails',
      meta: {
        menu: '/accountFreeze'
      },
      component: resolve => require(['@/pages/user/accountFreeze/detail'], resolve)
    },
    {
      // 冻结审批
      path: '/freezeAudit',
      name: 'freezeAudit',
      meta: {
        menu: '/freezeAudit',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/user/freezeAudit'], resolve)
    },
    {
      // 冻结审批详情
      path: '/freezeAuditDetails',
      name: 'freezeAuditDetails',
      meta: {
        menu: '/freezeAudit'
      },
      component: resolve => require(['@/pages/user/freezeAudit/detail'], resolve)
    },
    {
      // 账户解冻
      path: '/accountThaw',
      name: 'accountThaw',
      meta: {
        menu: '/accountThaw',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/user/accountThaw'], resolve)
    },
    {
      // 账户解冻详情
      path: '/accountThawDetails',
      name: 'accountThawDetails',
      meta: {
        menu: '/accountThaw'
      },
      component: resolve => require(['@/pages/user/accountThaw/detail'], resolve)
    },
    {
      // 解冻审批
      path: '/thawAudit',
      name: 'thawAudit',
      meta: {
        menu: '/thawAudit',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/user/thawAudit'], resolve)
    },
    {
      // 解冻审批详情
      path: '/thawAuditDetails',
      name: 'thawAuditDetails',
      meta: {
        menu: '/thawAudit'
      },
      component: resolve => require(['@/pages/user/thawAudit/detail'], resolve)
    },
    {
      // 批量提现
      path: '/batchWithdrawal',
      name: 'batchWithdrawal',
      meta: {
        menu: '/batchWithdrawal',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/user/batchWithdrawal'], resolve)
    },
    {
      // 提现详情
      path: '/batchWithdrawal/withdrawalDetails',
      name: '/batchWithdrawal',
      meta: {
        menu: '/batchWithdrawal/withdrawalDetails',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/user/batchWithdrawal/detail'], resolve)
    },

    // ----------------------------------------------------------------------回访-----------------------------------------------------------------
    {
      // 仪表板
      path: '/visit',
      name: 'visit',
      meta: {
        menu: '/visit'
      },
      component: resolve => require(['@/pages/visit/dashBoard'], resolve)
    },
    {
      // 保单回访
      path: '/visit/policy',
      name: 'policy',
      meta: {
        menu: '/visit/policy',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/visit/policy'], resolve)
    },
    {
      // 新增保单回访
      path: '/visit/policy/add',
      name: 'policyAdd',
      meta: {
        menu: '/visit/policy'
      },
      component: resolve => require(['@/pages/visit/policy/detail'], resolve)
    },
    {
      // 保单回访修改
      path: '/visit/policy/update',
      name: 'policyUpdate',
      meta: {
        menu: '/visit/policy'
      },
      component: resolve => require(['@/pages/visit/policy/detail'], resolve)
    },
    {
      // 保全服务
      path: '/visit/endorse',
      name: 'endorse',
      meta: {
        menu: '/visit/endorse',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/visit/endorse'], resolve)
    },
    {
      // 网销保单回访
      path: '/visit/online/policy',
      name: 'onlinePolicy',
      meta: {
        menu: '/visit/online/policy',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/visit/online'], resolve)
    },
    {
      // 网销保单回访明细
      path: '/visit/online/policy/update',
      name: 'onlinePolicyDetail',
      meta: {
        menu: '/visit/online/policy'
      },
      component: resolve => require(['@/pages/visit/online/detail'], resolve)
    },
    {
      // 保全回访修改
      path: '/visit/endorse/update',
      name: 'endorseUpdate',
      meta: {
        menu: '/visit/endorse'
      },
      component: resolve => require(['@/pages/visit/endorse/detail'], resolve)
    },
    {
      // 回访修改
      path: '/visit/modify',
      name: 'modify',
      meta: {
        menu: '/visit/modify',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/visit/modify'], resolve)
    },
    {
      // 回访修改明细
      path: '/visit/modify/update',
      name: 'modifyUpdate',
      meta: {
        menu: '/visit/modify'
      },
      component: resolve => require(['@/pages/visit/modify/detail'], resolve)
    },
    {
      // 修改审核
      path: '/visit/audit',
      name: 'audit',
      meta: {
        menu: '/visit/audit',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/visit/audit'], resolve)
    },
    {
      // 审核明细
      path: '/visit/audit/detail',
      name: 'auditDetail',
      meta: {
        menu: '/visit/audit'
      },
      component: resolve => require(['@/pages/visit/audit/detail'], resolve)
    },
    {
      // 回访查询
      path: '/visit/query',
      name: 'query',
      meta: {
        menu: '/visit/query',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/visit/query'], resolve)
    },
    {
      // 回访查询明细
      path: '/visit/query/detail',
      name: 'queryDetail',
      meta: {
        menu: '/visit/query'
      },
      component: resolve => require(['@/pages/visit/query/detail'], resolve)
    },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js